// src/hooks/useHandleSearch.ts

import { resolveDatesFromData } from "../helpers/resolveDatesFromData";

export function useHandleSearch(setSearchParams: (params: URLSearchParams, opts?: any) => void, setShouldFetch: (v: boolean) => void) {
	return (filters: Record<string, any>) => {
		const { data, ...rest } = filters;

		const { dataIni, dataFim } =
			data === "periodo"
				? {
						dataIni: rest.dataIni || "",
						dataFim: rest.dataFim || "",
				  }
				: resolveDatesFromData(data);

		const updated = {
			managerId: rest.selectedIdManager || "",
			clientFilter: rest.selectedIdClient || "",
			origem: rest.createdFrom || "",
			imovel: rest.busyImobile || "",
			typePeriod: rest.typePeriod || "",
			dataini: dataIni || "",
			datafim: dataFim || "",
			typeField: rest.filterField || "",
			busca: rest.textSearch || "",
			sketch: rest.isSketch === 1 ? "1" : "0",
			lmiSaldo: rest.isLMI === 1 ? "1" : "0",
			status: rest.statusSinister ?? [],
			pagina: "1",
			data,
		};

		const params = new URLSearchParams();
		Object.entries(updated).forEach(([key, val]) => {
			if (Array.isArray(val)) {
				params.set(key, val.map((v) => v.trim()).join(","));
			} else {
				params.set(key, typeof val === "string" ? val.trim() : val ?? "");
			}
		});

		setSearchParams(params, { replace: true });
		setShouldFetch(true);
	};
}
